import { Pipe, PipeTransform } from '@angular/core';
import { IClientFieldsVisibility } from '@app/core/model/env-config.model';
import { ProfileService } from '@app/core/services/profile.service';
import { isClientFieldVisible } from '@app/transaction-builder/utils/form.util';

@Pipe({
  name: 'isClientFieldVisible',
})
export class IsClientFieldVisiblePipe implements PipeTransform {
  constructor(private profileService: ProfileService) {}

  transform(fieldName: keyof IClientFieldsVisibility): boolean {
    const clientFieldsVisibility = this.profileService.getCurrentProfile().clientFieldsVisibility;
    return isClientFieldVisible(clientFieldsVisibility, fieldName);
  }
}
